import React from "react";
import { CLIENT_LOGOS } from "@/data/content";

export const LogoMarquee = () => {
    const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
    return (
        <section
            className="relative bg-[hsl(var(--bg))] py-12 lg:py-14"
            aria-label="Trusted by"
        >
            <div className="mx-auto max-w-7xl container-px">
                <div className="text-[11px] uppercase tracking-[0.22em] font-mono text-[hsl(var(--text-subtle))] mb-6">
                    — Trusted by founders, CMOs, and investors building the next category leaders
                </div>
            </div>
            <div
                className="marquee-pause marquee-fade overflow-hidden"
                data-testid="client-logos-marquee"
            >
                <div className="marquee marquee-slow">
                    {items.map((name, i) => (
                        <span
                            key={`${name}-${i}`}
                            className="shrink-0 select-none font-display text-3xl lg:text-4xl tracking-[0.02em] text-[hsl(var(--text-subtle))]/70 hover:text-[hsl(var(--text))] transition-colors duration-300"
                        >
                            {name}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LogoMarquee;
